import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';

export default function HealingTrendChart({ reports }) {
  if (!reports || reports.length < 2) {
    return (
      <div className="flex items-center justify-center h-48 text-sm text-slate-400">
        Mindestens 2 Berichte für den Heilungstrend erforderlich
      </div>
    );
  }

  const data = [...reports]
    .sort((a, b) => new Date(a.datum) - new Date(b.datum))
    .map((r) => ({
      datum: new Date(r.datum).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }),
      flaeche: r.flaeche || 0,
      schmerz: r.schmerz_nrs || 0,
    }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload) return null;
    return (
      <div className="bg-white border border-slate-200 rounded-lg shadow-lg p-3 text-xs">
        <p className="font-medium text-slate-700 mb-1">{label}</p>
        {payload.map((p, i) => (
          <p key={i} style={{ color: p.color }}>
            {p.name === 'flaeche' ? 'Fläche' : 'Schmerz'}: {p.value} {p.name === 'flaeche' ? 'cm²' : '/10'}
          </p>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full h-56" data-testid="healing-trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
          <defs>
            <linearGradient id="colorFlaeche" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0F766E" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#0F766E" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis dataKey="datum" tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} />
          <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Area type="monotone" dataKey="flaeche" stroke="#0F766E" strokeWidth={2.5} fill="url(#colorFlaeche)" name="flaeche" dot={{ r: 4, fill: '#0F766E', stroke: '#fff', strokeWidth: 2 }} />
          <Line type="monotone" dataKey="schmerz" stroke="#D97706" strokeWidth={2} strokeDasharray="5 5" name="schmerz" dot={{ r: 3, fill: '#D97706', stroke: '#fff', strokeWidth: 2 }} />
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex items-center justify-center gap-6 mt-2 text-xs text-slate-500">
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-0.5 bg-teal-700 rounded-full" />
          Wundfläche (cm²)
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-0.5 bg-amber-600 rounded-full" style={{ borderBottom: '1px dashed' }} />
          Schmerz (NRS)
        </span>
      </div>
    </div>
  );
}
